import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface IInfoBadge {
  sxStyle: {};
  text: string | ReactNode;
  mx?: string;
}

export default function TextBadge({ text, mx, sxStyle }: Readonly<IInfoBadge>) {
  return (
    <Typography
      component={Stack}
      variant="warningMediumBold"
      sx={{
        // @ts-ignore
        ...sxStyle,
        borderRadius: "99px",
        px: "16px",
        py: "3px",
        mx: mx ? mx : "auto",
      }}
    >
      {text}
    </Typography>
  );
}
